import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-info-tooltip',
  standalone: true,
  templateUrl: './info-tooltip.component.html',
  styleUrl: './info-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoTooltipComponent {
  /** Array of bullet-point strings shown inside the tooltip popup */
  items = input<string[]>([]);
  /** When false, hides the info icon and keeps the tooltip always visible */
  showIcon = input<boolean>(true);
}
